<template>
  <div class="progress-bar">
    <div class="cursor" :style="setCursorWidth"></div>
  </div>
</template>

<script>
  export default {
    name: 'DisplayProgressBar',
    props: {
      percentage: {
        type: Number,
        default: 0,
      },
    },

    computed: {
      setCursorWidth() {
        return {
          width: `${this.percentage}%`,
        };
      }
    },
  }
</script>

<style scoped>
.progress-bar {
  width: 246px;
  height: 18px;
  border-radius: 28px;
  background: #D9D9D9;
}

.progress-bar .cursor {
  height: 100%;
  border-radius: 28px;
  background: #FFB704;
}
</style>



// WEBPACK FOOTER //
// DisplayProgressBar.vue?76b328f8